import React, { useEffect } from 'react'
import * as BTConstant from '../../utils/bt-constant' 
const paths = [
  `${BTConstant.DOC_PREFIX}/guides/drop-in/overview`
]

export default (WrappendComponent) => {
  function runDemo() {
    let authorization = 'sandbox_f252zhq7_hh4cpc39zq4rgjcg';
    let submitButton = document.querySelector('#submit');

    braintree.dropin.create({ // eslint-disable-line no-undef
      authorization,
      container: '#dropin-container',
      paypal: {
        flow: 'vault'
      }
    }, function (err, dropinInstance) {
      if (err) {
        return;
      }

      dropinInstance.on('paymentMethodRequestable', function () {
        submitButton.removeAttribute('disabled');
      });

      dropinInstance.on('noPaymentMethodRequestable', function () {
        submitButton.setAttribute('disabled', true);
      });

      submitButton.addEventListener('click', function () {
        dropinInstance.requestPaymentMethod(function (reqErr) {
          if (reqErr) {
            return;
          }
        });
      }, false);
    });
  }
  return function WithBTScriptLoader(props) {
    useEffect(() => {
      if (
        props.loaded && props.location &&
        (paths.includes(props.location.pathname) ||
          paths.includes(props.location.pathname.slice(0, -1)))
      ) {
        try {
          runDemo();
        } catch (err) {
          console.log('Drop-in demo error: ', err)
        }
      }
    }, [props.loaded])
    return <WrappendComponent {...props} />
  }
}
